export { ScopedAccessBanner } from './scoped-access-banner'
